import React, {useState, useEffect, Fragment} from 'react'
import apiClient from '../api/apiClient'
import {useAuth} from '../context/AuthContext'
import './StaffPage.css'
import './StudentClassStudentAdminPage.css'
import './ReceivedExams.css'

export default function ReceivedExams(){
    const {user} = useAuth()
    const schoolID = user.scId
    const [testGroups, setTestGroups] = useState([])
    const [currentTestGroup, setCurrentTestGroup] = useState(null)
    const [displayTestGroups, setDisplayTestGroups] = useState([])
    const [studentsWithExams, setStudentsWithExams] = useState([])
    const [currentTestType, setCurrentTestType] = useState('ALLE')
    const [searchTerm, setSearchTerm] = useState('')

    async function fetchTestGroups(){
        try{
            console.log(`gettgin recived exams from ${schoolID}`)
            const result = await apiClient.get('/api/testgroup/getallreceived', 
                {params: {schoolID : schoolID}}
            )
            setTestGroups(result.data)
            setDisplayTestGroups(result.data) // hack?? 
            console.log(result?.data[0]?.navn)
        }catch(e){
            console.log("fejl ved fetch af test groups")
            console.log(e)
        }
    }

    async function fetchStudentsWithExams(){
        try{
            const result = await apiClient.get('/api/testgroup/getstudentswithexams',
                {params: {testGroupID: currentTestGroup?.id || null}}
            )
            setStudentsWithExams(result.data)
            console.log(result.data)
        }catch(e){
            console.log(" error in getting students with exams")
            console.log(e)
        }
    }

    useEffect(()=>{
        fetchTestGroups()
        fetchStudentsWithExams()
    }, [currentTestGroup])

    useEffect(()=>{
        const filteredTestGroupArray = testGroups.filter(tg => 
            {
                if(!(tg.studie === currentTestType || currentTestType ==='ALLE')) return false;
                const haystack = (tg.navn+tg.studie+tg.sprogcenter_navn).toLowerCase()
                if(!haystack.includes(searchTerm.toLowerCase())) return false;
                return true;
            })
        setDisplayTestGroups(filteredTestGroupArray)
    }, [currentTestType, searchTerm, testGroups])


    async function handleDownload(filename){
        try{
            const res = await apiClient.get('/api/downloadfile', {
                params: {filename},
                responseType: 'blob'
            })
            const url = window.URL.createObjectURL(res.data)
            const a = document.createElement('a')
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
        }catch(e){
            console.log("fejl ved download af fil")
            console.log(e)
        }
    }

    /// NOTE NOTE NOTE. currentTestGroup er altid Null, så else delen bliver aldrig eksekveret lige p.t. 

    return(
        <div className="panel-container received-exams-page">
                {currentTestGroup === null ?(
                    <div className="panel">
                        <div className="table-bar">
                            <input 
                                type="text"
                                className="search-input"
                                placeholder="Søg..."
                                value={searchTerm}
                                onChange={(e)=>setSearchTerm(e.target.value)}
                            />
                            <select
                                value={currentTestType}
                                onChange={(e) =>setCurrentTestType(e.target.value)}
                                aria-label="Filtrér efter prøvetype"
                            >
                                <option key="ALLE" value="ALLE">Alle</option>
                                <option key="PD1" value="PD1">PD1</option>
                                <option key="PD2" value="PD2">PD2</option>
                                <option key="PD3" value="PD3">PD3</option>
                            </select>
                        </div>
                        <table className="censor-table">
                            <thead>
                                <tr>
                                    <th>Prøveform</th>
                                    <th>Afsender sprogcenter</th>
                                    <th>Prøvegruppe</th>
                                    <th>Filnavn</th>
                                    <th>Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayTestGroups.length === 0 ? (
                                    <tr>
                                        <td colSpan={5} className="drop-zone-hint received-muted">
                                            Ingen modtagne prøvegrupper
                                        </td>
                                    </tr>
                                ) : (
                                displayTestGroups.map(tg => (
                                    <Fragment key={tg.id}>
                                        <tr>
                                            <td>{tg.studie}</td>
                                            <td>{tg.sprogcenter_navn}</td>
                                            <td>{tg.navn}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        {(!tg?.examupload_filenames || tg.examupload_filenames.length === 0) ?
                                        (
                                            <tr>
                                                    <td colSpan={3} />
                                                    <td colSpan={2} className="received-muted">Ingen uploadede filer</td>
                                            </tr>
                                        ):(
                                          tg.examupload_filenames.map((fileName) => (
                                            <tr key={`${tg.id}-${fileName}`}>
                                                    <td colSpan={3} />
                                                    <td>
                                                        <div className="upload-file-name">{fileName}</div>
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="tg-table-action"
                                                            onClick={()=>handleDownload(fileName)}
                                                        >
                                                            Download
                                                        </button>
                                                    </td>
                                            </tr>
                                            ))
                                        )
                                        }
                                    </Fragment>
                                ))
                                )}
                            </tbody>
                        </table>
                    </div>
                ):(
                    <div className="panel">
                        <span className="panel-text">
                            <b>Prøvegruppe: </b> {currentTestGroup?.navn}
                        </span>
                        {currentTestGroup?.examupload_filenames?.length >0 &&
                            <div>
                                <span className="exam-section-title">Upload på hele prøvegruppen</span>
                            <table className="censor-table">
                                <thead>
                                    <tr>
                                        <th>Filnavn</th>
                                        <th>Download</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {currentTestGroup.examupload_filenames.map(fileName => (
                                    <tr key={fileName}>
                                        <td>
                                            <div className="upload-file-name">{fileName}</div>
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                className="tg-table-action"
                                                onClick={()=>handleDownload(fileName)}
                                            >
                                                Download
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            </div>
                        }

                        {studentsWithExams.length > 0 && (
                            <div>
                            <span className="exam-section-title">Upload på individuelle kursister</span>
                            <table className="censor-table">
                                <thead>
                                    <tr>
                                        <th>Kursist nr.</th>
                                        <th>Fornavn(e)</th>
                                        <th>Efternavn</th>
                                        <th>Skriftlig prøve</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {studentsWithExams.map(student => (
                                        <tr key={student.id}>
                                            <td>{student.id}</td>
                                            <td>{student.fornavne}</td>
                                            <td>{student.efternavn}</td>
                                            <td>
                                                <div className="upload-file-name">{student.examupload_filename}</div>
                                            </td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="tg-table-action"
                                                    onClick={() => handleDownload(student.examupload_filename)}
                                                >
                                                    Download
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            </div>
                        )}
                    </div>
                )}
        </div>
    )
}
